// Curated list of US IANA timezones for location clinic-hours (ENG-1537).
// `value` is the IANA name persisted on the backend; `label` is a friendly,
// senior-readable description. Ordered east-to-west, most common first.

export interface TimezoneOption {
  value: string;
  label: string;
}

export const US_TIMEZONES: TimezoneOption[] = [
  { value: "America/New_York", label: "Eastern Time — New York" },
  { value: "America/Chicago", label: "Central Time — Chicago" },
  { value: "America/Denver", label: "Mountain Time — Denver" },
  { value: "America/Phoenix", label: "Mountain Time (no DST) — Arizona" },
  { value: "America/Los_Angeles", label: "Pacific Time — Los Angeles" },
  { value: "America/Anchorage", label: "Alaska Time — Anchorage" },
  { value: "Pacific/Honolulu", label: "Hawaii Time — Honolulu" },
  { value: "America/Puerto_Rico", label: "Atlantic Time — Puerto Rico" }
];

// Backend default when a location has no timezone set.
export const DEFAULT_TIMEZONE = "America/New_York";

export const getTimezoneLabel = (value?: string | null): string => {
  if (!value) return "";
  return US_TIMEZONES.find((tz) => tz.value === value)?.label ?? value;
};

/**
 * Resolve a stored IANA string to a picker option. Values outside the curated
 * {@link US_TIMEZONES} list (the backend accepts any valid IANA name) get a
 * synthesized option so they display and round-trip on save instead of being
 * silently reset to null — see ENG-1537.
 */
export const toTimezoneOption = (
  value?: string | null
): TimezoneOption | null => {
  if (!value) return null;
  return US_TIMEZONES.find((tz) => tz.value === value) ?? { value, label: value };
};
